import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import Toasted from 'vue-toasted';
import BootstrapVue from 'bootstrap-vue'
import AsyncComputed from 'vue-async-computed'
import App from './App.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookSquare, faTwitterSquare, faVimeoSquare } from '@fortawesome/free-brands-svg-icons'
import { faRssSquare } from '@fortawesome/free-solid-svg-icons'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBOmBwTlDlTVLkhDvHrWDsey-S9I3LeGSE'
  }
})

Vue.use(Toasted)
Vue.use(AsyncComputed)

Vue.config.productionTip = false

library.add(faFacebookSquare, faTwitterSquare, faVimeoSquare, faRssSquare)

new Vue({
  render: h => h(App),
}).$mount('#app')
